var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-row',[_c('van-col',{staticStyle:{"text-align":"center","margin-top":"10vh"},attrs:{"span":"24"}},[_c('van-icon',{attrs:{"name":"checked","color":"#1989fa","size":"60px"}})],1)],1),_c('p',{staticClass:"font14 mc mt"},[_vm._v("提交成功！")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }